// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.billboard-password-field .ant-input-outlined:focus,
.ant-input-outlined:focus-within {
  z-index: 0 !important;
  border-color: #fff;
  box-shadow: none;
}
.login-title {
  font-size: 23px;
  color: #333;
  margin-bottom: 0.2rem;
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/features/LoginPage/loginfields/LoginFields.css"],"names":[],"mappings":"AAAA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB","sourcesContent":[".billboard-password-field .ant-input-outlined:focus,\n.ant-input-outlined:focus-within {\n  z-index: 0 !important;\n  border-color: #fff;\n  box-shadow: none;\n}\n.login-title {\n  font-size: 23px;\n  color: #333;\n  margin-bottom: 0.2rem;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
